import React from 'react';
import { SimpleSearchFilter } from 'api/dashboard/widget';
import {
  JiraConfig,
  MappingMechanism,
  ProjectMappingMechanism,
} from 'api/integrations';
import { Field } from 'api/tasks';
import { JiraFields } from 'components/organisms/projects/project-create/jira-fields';
import { useQueryJiraEpic } from 'queries/jira-integration';

export const FixedFields = {
  ARR: 'annualizedRecurringRevenue',
  ProjectFee: 'projectFee',
  BudgetHours: 'budgetedHours',
  JiraEpicMapping: 'jiraEpicMapping',
};

export const fixedProjectFields = Object.values(FixedFields)
  .filter((field) => ![FixedFields.ARR, FixedFields.ProjectFee].includes(field))
  .map(
    (field, i) =>
      ({
        fieldLabel: field,
        fieldType: field,
        fieldId: i * -1, // all fixed fields are with negative id
      } as Field),
  );

export const fixedFieldsRenderer =
  ({
    filteredFieldIds,
    jiraConfig,
  }: {
    filteredFieldIds: string[];
    fieldFilters: Omit<SimpleSearchFilter, 'match'>;
    jiraConfig?: JiraConfig;
  }) =>
  (field: Field) => {
    const { fieldType } = field;

    const canQueryJiraEpics = Boolean(
      jiraConfig?.integrationId && jiraConfig?.settingsMeta?.fixedProjectId,
    );

    const { data: epicOptions, isLoading } = useQueryJiraEpic(
      jiraConfig?.integrationId as any as number,
      jiraConfig?.settingsMeta?.fixedProjectId as any as string,
      {
        enabled: canQueryJiraEpics,
      },
    );

    const showJiraMapping =
      jiraConfig != null &&
      jiraConfig.settingsMeta.projectMappingMechanism ===
        ProjectMappingMechanism.Fixed &&
      jiraConfig.settingsMeta.epicMappingMechanism ===
        MappingMechanism.PromptDuringProjectcreation;

    switch (fieldType) {
      case FixedFields.JiraEpicMapping: {
        if (jiraConfig != null && showJiraMapping) {
          return (
            <JiraFields
              isLoading={isLoading}
              options={epicOptions}
              jiraConfig={jiraConfig!}
              hidden={!filteredFieldIds.includes(field.fieldId.toString())}
            />
          );
        }

        return null;
      }
      default: {
        return null;
      }
    }
  };
